import { render, staticRenderFns } from "./SubmitDocsList.vue?vue&type=template&id=5ee3afef&scoped=true&"
import script from "./SubmitDocsList.vue?vue&type=script&lang=js&"
export * from "./SubmitDocsList.vue?vue&type=script&lang=js&"
import style0 from "./SubmitDocsList.vue?vue&type=style&index=0&id=5ee3afef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee3afef",
  null
  
)

export default component.exports